import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ShipmentGrid from "../components/Shipping/ShipmentGrid.jsx";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";
import TabNavigation from "../components/TabNavigation.jsx";

const SHIPPING_TABS = [
    { label: "Needs Label", value: 0, view: "needs-label" },
    { label: "Ready to Ship", value: 1, view: "ready-to-ship" },
    { label: "All", value: 2, view: "all" },
];

function tabFromSearchParams(searchParams) {
    const tab = parseInt(searchParams.get("t"), 10);
    if (SHIPPING_TABS.some((item) => item.value === tab)) return tab;
    // Legacy ?v=all bookmark
    if (searchParams.get("v") === "all") return 2;
    return 0;
}

export default function Shipping() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [value, setValue] = useState(() => tabFromSearchParams(searchParams));

    const handleChange = (_event, newValue) => {
        setValue(newValue);
        setSearchParams(
            (prev) => {
                const next = new URLSearchParams(prev);
                next.set("t", String(newValue));
                next.delete("v");
                // Preserve share/search q across shipping tabs.
                return next;
            },
            { replace: true }
        );
    };

    useEffect(() => {
        const fromUrl = tabFromSearchParams(searchParams);
        if (fromUrl !== value) setValue(fromUrl);

        const raw = searchParams.get("t");
        const valid =
            raw != null &&
            SHIPPING_TABS.some((tab) => tab.value === parseInt(raw, 10));
        if (valid && searchParams.get("v") == null) return;

        setSearchParams(
            (prev) => {
                const next = new URLSearchParams(prev);
                next.set("t", String(fromUrl));
                next.delete("v");
                return next;
            },
            { replace: true }
        );
    }, [searchParams, setSearchParams, value]);

    const activeView =
        SHIPPING_TABS.find((tab) => tab.value === value)?.view || "needs-label";

    return (
        <CatalogPageShell
            title="Shipping"
            subtitle="Pending Label orders from the shared pull — print labels after Fulfillment has assigned/picked units."
        >
            <div className="app-page-stack">
                <div style={{ flexShrink: 0 }}>
                    <TabNavigation
                        value={value}
                        onChange={handleChange}
                        tabs={SHIPPING_TABS}
                    />
                </div>
                <ShipmentGrid key={activeView} view={activeView} />
            </div>
        </CatalogPageShell>
    );
}
